import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/order-management";
const options = { role: ROLE.RESTAURANT };

export const addOrder = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const listOrder = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const editOrder = async (values) => {
  return await axiosInstance(options).put(`${path}/update`, values);
};

export const deleteOrder = async (values) => {
  return await axiosInstance(options).delete(
    `${path}/delete?o_id=${values.o_id}`,
  );
};

export const orderDetails = async (values) => {
  return await axiosInstance(options).get(
    `${path}/details?o_id=${values.o_id}`,
  );
};

export const productOption = async () => {
    return await axiosInstance(options).get(`${path}/product-option`);
}


